export default "../images/stackloans-partners-with-Sofi_PORTAL_US.png?fe94c3fe8293b6c7546fed2f544fdb91";